import script from "./ordergood.vue?vue&type=script&setup=true&lang=js"
export * from "./ordergood.vue?vue&type=script&setup=true&lang=js"

import "./ordergood.vue?vue&type=style&index=0&id=50b75be5&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b75be5"]])

export default __exports__